export default "__VITE_ASSET__BGSH$mTs__"